import React, { forwardRef } from 'react';
/**
 * Removes some props before rendering the component (mostly used with styled-components)
 * Motivation: custom props gets added to DOM and can cause invalid HTML or console warnings
 * Return with forwardRef(), to avoid losing ref (using stateless function)
 */

/**
 * @deprecated Use Transient props.
 * Example:
 * <Component $prop={value} />
 * const Comp = styled.div` color: ${props => props.$prop}`;
 * More details - https://styled-components.com/docs/api#transient-props
 */

export var withoutProps = function withoutProps(Component, propKeysToRemove) {
  return forwardRef(function (props, ref) {
    var sourceProps = Object.keys(props);
    var newProps = sourceProps.reduce(function (acc, key) {
      if (propKeysToRemove.indexOf(key) === -1) {
        acc[key] = props[key];
      }

      return acc;
    }, {});
    return React.createElement(Component, Object.assign({
      ref: ref
    }, newProps));
  });
};